var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMolinete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 402,
    height: 402,
    viewBox: "0 0 402 402",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_433_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.7 0H318.8C362.3 0 397.5 35.2 397.5 78.7V314.8C397.5 358.3 362.3 393.5 318.8 393.5H82.7C39.2 393.5 4 358.3 4 314.8V78.7C4 35.3 39.2 0 82.7 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.861 62.259C160.118 62.5972 159.38 63.542 157.854 68.6834C156.869 71.9986 156.064 75.2833 156.064 75.9831C156.064 76.6817 165.872 87.0504 177.859 99.0249L199.654 120.797V225.805V330.813L211.504 331.653C218.021 332.116 229.685 332.116 237.423 331.654L251.492 330.814V196.659V62.5029L244.129 62.3179C228.575 61.928 165.921 61.8832 162.861 62.259ZM205.153 71.5356C204.72 71.9668 204.367 76.7382 204.367 82.1388V91.9562L222.922 91.9585L241.478 91.962L241.1 81.3553L240.722 70.7498H223.33C213.764 70.7498 205.584 71.1033 205.153 71.5356ZM156.233 93.4488C154.844 95.6967 153.707 98.1354 153.707 98.8694C153.707 99.8402 140.898 100.203 106.666 100.203C65.4725 100.203 59.3957 100.433 57.7734 102.054C55.4089 104.418 55.4089 107.769 57.7734 110.134C59.3945 111.753 65.4171 111.984 106.061 111.984H152.497L154.344 116.402C156.608 121.823 161.11 126.664 165.626 128.536L169.023 129.943V177.591C169.023 208.183 169.46 226.056 170.242 227.519C171.888 230.593 177.939 230.593 179.585 227.519C180.367 226.057 180.804 208.351 180.804 178.128V131.017L184.785 129.703C186.975 128.981 189.731 127.324 190.909 126.022C193.016 123.694 192.758 123.359 175.906 106.507L158.76 89.3607L156.233 93.4488Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_433_11",
    x: 0,
    y: 0,
    width: 401.5,
    height: 401.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_433_11"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_433_11",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMolinete);
export default __webpack_public_path__ + "static/media/Molinete.a0cb3a2d.svg";
export { ForwardRef as ReactComponent };